var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiFormat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 45,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 9165,
    transform: "translate(-777 -2035)",
    fill: "#180045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1",
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -778,
    y: -1957,
    width: 1920,
    height: 9087,
    fill: "#180045",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "features",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3103 3.23033C29.3103 2.51033 34.3603 3.43033 36.7903 6.67029C38.9303 9.67609 39.8983 13.3608 39.5103 17.0303C39.1103 20.7603 36.6403 23.9503 33.5203 26.0303C31.3503 27.4903 28.4803 27.7303 25.9503 27.0503C23.4303 26.3703 19.9203 25.3103 18.1803 23.3703C15.5103 20.2703 15.2603 17.0703 15.0203 13.0103C14.9203 11.1703 15.8103 7.74029 17.5403 7.11029C17.5903 7.11029 21.3003 3.96033 25.3103 3.23033Z",
    fill: "#FFD15A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.15012 41.451C0.929117 32.6993 0.912099 23.9436 1.1001 15.191C1.1001 14.481 1.6201 14.111 2.1601 14.071L2.24011 14.011C7.74011 8.96098 11.8401 6.24098 16.6601 2.85102C17.3501 2.17102 18.6601 2.67102 18.6201 3.66102C18.4701 9.45098 18.8201 15.231 19.1801 21.021C19.5601 27.391 19.9501 33.771 19.6701 40.141C19.6201 40.821 19.1701 41.181 18.5301 41.271C13.1321 41.9098 7.71109 42.3468 2.28009 42.581C1.65009 42.631 1.15012 42.041 1.15012 41.451Z",
    fill: "#B8DDF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.690071 13.0305C6.14007 8.43049 11.8901 4.17047 17.9701 0.370473C18.5701 -0.299527 19.9901 -0.059527 19.9901 1.08047C20.1401 7.36049 20.2101 13.6105 20.2801 19.8805L20.4001 29.2505C20.4001 30.6905 18.1201 30.6905 18.1201 29.2505L18.0001 19.8705C17.9401 14.3105 17.8801 8.75049 17.7601 3.17047C12.4131 6.62429 7.28607 10.4083 2.41007 14.5005L2.28007 41.7705C7.90007 40.9205 13.5501 40.4605 19.2501 40.4605C20.7001 40.4605 20.7001 42.7205 19.2501 42.7205C13.2901 42.7205 7.33007 43.1705 1.41007 44.1705C0.650072 44.2905 0.130067 43.7205 0.030067 43.1305C0.00906697 43.0387 -0.000931811 42.9447 6.81892e-05 42.8505L0.140083 13.9705C0.140083 13.5105 0.370091 13.1905 0.680091 13.0305H0.690071Z",
    fill: "#1E2882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.3509 9.80152C24.0809 9.22152 27.8609 9.13152 31.6409 9.27152L30.5009 8.14152C30.7309 16.3615 30.9509 24.5915 31.2709 32.8615C31.3209 34.3115 33.5909 34.3115 33.5509 32.8615C33.2309 24.6415 33.0009 16.4115 32.7709 8.14152C32.7709 7.50152 32.2709 7.05152 31.6409 7.01152C27.6409 6.87152 23.6709 7.01152 19.7609 7.64152C18.3009 7.87152 18.8909 10.0415 20.3609 9.81152L20.3509 9.80152ZM21.5309 38.7015C23.7209 38.4215 25.9509 38.2915 28.1309 38.3315C29.5909 38.3315 29.5909 36.0715 28.1309 36.0715C25.9009 36.0715 23.7209 36.2115 21.5309 36.4415C20.0809 36.6215 20.0809 38.8815 21.5309 38.7015Z",
    fill: "#1E2882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.0296 15.3213C22.5796 15.1013 25.1296 14.8713 27.6796 14.8713C29.1296 14.8713 29.1296 12.6113 27.6796 12.6113C25.7696 12.6113 23.8596 12.7613 21.9396 12.9113C21.3096 12.9713 20.6696 13.0113 20.0396 13.0613C18.5796 13.1613 18.5796 15.4113 20.0396 15.3213H20.0296ZM20.0296 23.1013C22.2596 22.8613 24.4896 22.8713 26.7296 22.8713H27.6796C29.1296 22.8713 29.1296 20.6113 27.6796 20.6113C25.1296 20.6113 22.5796 20.6113 20.0296 20.8413C18.5796 20.9813 18.5796 23.2413 20.0296 23.1013ZM27.3596 29.8413C24.7596 29.8413 22.1296 29.8413 19.5796 30.3413C18.1696 30.6013 17.5296 28.4413 18.9396 28.1613C21.7206 27.6967 24.5406 27.5025 27.3596 27.5813C28.8096 27.5813 28.8096 29.8413 27.3596 29.8413ZM3.41959 20.5213C4.46959 25.4113 5.4196 30.3313 6.5196 35.2213C6.7496 36.2513 8.51959 36.3013 8.69959 35.2213C9.51959 30.6913 10.0696 26.0813 10.6996 21.5213H8.5196C9.3796 25.3213 10.2896 29.1213 11.5696 32.8213C11.9696 34.0413 13.7096 33.8213 13.7996 32.5013C14.2996 26.5413 14.8396 20.5713 15.3396 14.6013C15.4796 13.1513 13.2096 13.1513 13.0696 14.6013C12.5696 20.5713 12.0196 26.5413 11.5196 32.5013C12.2496 32.4113 13.0196 32.3213 13.7496 32.1913C12.5256 28.4836 11.5076 24.7112 10.6996 20.8913C10.4796 19.8513 8.6596 19.7513 8.5196 20.8913C7.8396 25.4513 7.3396 30.0213 6.5196 34.5913H8.69959C7.59959 29.7013 6.64958 24.7713 5.59958 19.8913C5.32958 18.4913 3.14959 19.0813 3.41959 20.5213Z",
    fill: "#1E2882"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -928,
    y: -2107,
    width: 2220,
    height: 9387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 9165,
    fill: "white",
    transform: "translate(-777 -2035)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1055,
    fill: "white",
    transform: "translate(-777 -568)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiFormat);
export default __webpack_public_path__ + "static/media/multi-format.0345d2fe6ca55278f177e9a54207ae20.svg";
export { ForwardRef as ReactComponent };